/*eslint-disable*/
import React from "react";
import { Flex, Link, List, ListItem, Text } from "@chakra-ui/react";
import {
  HELP_CENTRE_URL,
  MARKETING_SITE_URL,
  PRODUCT_NAME,
} from "../../constants/brand";

interface FooterProps {
  [key: string]: any;
}

export default function Footer(props: FooterProps) {
  return (
    <Flex
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent="space-between"
      px="30px"
      pb="20px"
      {...props}
    >
      <Text
        color="gray.400"
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", xl: "0px" }}
      >
        &copy; 2025, Made with ❤️ by{" "}
        <Link color="#38BBD1" href={MARKETING_SITE_URL} target="_blank">
          {PRODUCT_NAME}
        </Link>
      </Text>
      <List display="flex">
        <ListItem
          me={{
            base: "20px",
            md: "44px",
          }}
        >
          <Link color="gray.400" href={HELP_CENTRE_URL} target="_blank">
            Help Centre
          </Link>
        </ListItem>
        <ListItem
          me={{
            base: "20px",
            md: "44px",
          }}
        >
          <Link color="gray.400" href={`${MARKETING_SITE_URL}/privacy`} target="_blank">
            Privacy
          </Link>
        </ListItem>
      </List>
    </Flex>
  );
}
